import { useState } from "react";
import { Phone } from "lucide-react";
import { CONTACT, waLink } from "@/lib/content";

export const MobileActionBar = () => (
  <div
    data-testid="mobile-action-bar"
    className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-2 border-t border-white/10 bg-[#16220F]/95 p-3 pb-[max(12px,env(safe-area-inset-bottom))] backdrop-blur-md sm:hidden"
  >
    <a
      data-testid="mobile-bar-whatsapp"
      href={waLink("Olá, gostaria de falar com a Melo Agro Engenharia.")}
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp"
      className="flex items-center justify-center gap-2 rounded-full bg-[#25D366] py-3 text-sm font-semibold text-white"
    >
      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
        <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.05 21.5h-.01a9.4 9.4 0 0 1-4.8-1.32l-.34-.2-3.57.94.95-3.48-.22-.36a9.43 9.43 0 1 1 7.99 4.42zm8.02-17.45A11.27 11.27 0 0 0 12.05.75C5.8.75.72 5.83.72 12.08c0 2 .52 3.95 1.52 5.66L.62 23.62l6.02-1.58a11.3 11.3 0 0 0 5.41 1.38h.01c6.25 0 11.33-5.08 11.33-11.33 0-3.03-1.18-5.87-3.32-8.01z" />
      </svg>
      WhatsApp
    </a>
    <a
      data-testid="mobile-bar-call"
      href={`tel:+${CONTACT.wa}`}
      aria-label="Ligar por telefone"
      className="flex items-center justify-center gap-2 rounded-full bg-[#F9F8F3] py-3 text-sm font-semibold text-[#16220F]"
    >
      <Phone className="h-4 w-4" /> Ligar
    </a>
  </div>
);
